import gsap from 'gsap';
import Component from '../../classes/Component';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Timeline } from 'gsap/gsap-core';

const root = '.js-home';
const cubeBigSelector = '.js-cube-big';
const cubeSmallSelector = '.js-cube-small';

const scrollSelector = '.js-scroll';

const logoSelector = '.js-logo';
const label1Selector = '.js-label-1';
const underlinel1Selector = '.js-underline-1';
const label2Selector = '.js-label-2';
const label2ExlcSelector = '.js-label-2-excl';
const underlinel2Selector = '.js-underline-2';
const label3Selector = '.js-label-3';
const underlinel3Selector = '.js-underline-3';
const dateSelector = '.js-date';
const dateElemSelector = '.js-date-elem';
const dateElem2Selector = '.js-date-elem-2';

const date1Selector = '.js-date-1';
const date2Selector = '.js-date-2';
const date3Selector = '.js-date-3';
const date3CircleSelector = '.js-date-3-circle';
const date4Selector = '.js-date-4';
const labelSelector = '.js-date-label';

const contentItemRightSelector = '.js-content-item-right';
const contentItemleftSelector = '.js-content-item-left';

const contentBottomSelector = '.js-content-bottom';

gsap.registerPlugin(ScrollTrigger);

export function homeAnimations() {

  const duration = 150;

  const mobileDuration = .5;

  let introAnimation = null;
  let logoAnimation = null;

  gsap.set('.home__wrapper', {
    opacity: 1,
  })

  gsap.set(date1Selector, {
    opacity: 1,
  })
  gsap.set(date2Selector, {
    opacity: 1,
  })
  gsap.set(date3Selector, {
    opacity: 1,
  })
  gsap.set(date4Selector, {
    opacity: 1,
  })
  gsap.set(date3CircleSelector, {
    opacity: 1,
  })
  gsap.set(labelSelector, {
    opacity: 1,
  })
  gsap.set(contentItemRightSelector, {
    opacity: 1,
  })
  gsap.set(contentItemleftSelector, {
    opacity: 1,
  }, "<")
  gsap.set(contentBottomSelector, {
    opacity: 1,
  });
  gsap.set(dateElem2Selector, {
    opacity: 1,
  });

  let mm = gsap.matchMedia();

  mm.add("(min-width: 992px)", () => {
    introAnimation = gsap.timeline({

      onComplete: function () {

        logoAnimation = gsap.timeline({
          scrollTrigger: {
            trigger: root,
            pin: true,
            start: "top top",
            end: "+=1500",
            scrub: true,
          },

          onComplete: function () {
            gsap.set(cubeBigSelector, {
              animation: "5s infinite ease-in-out cubeanim1",
            })
            gsap.set(cubeSmallSelector, {
              animation: "5s infinite ease-in-out cubeanim2",
            })

            gsap.set(label1Selector, {
              animation: "6s infinite ease-in-out labelanim1",
            })
            gsap.set(underlinel1Selector, {
              animation: "6s infinite ease-in-out lineanim1",
            })

            gsap.set(label2Selector, {
              animation: "6s infinite ease-in-out labelanim2",
            })
            gsap.set(underlinel2Selector, {
              animation: "6s infinite ease-in-out lineanim2",
            })

            gsap.set(label3Selector, {
              animation: "6s infinite ease-in-out labelanim3",
            })
            gsap.set(underlinel3Selector, {
              animation: "6s infinite ease-in-out lineanim3",
            })
            gsap.set(dateSelector, {
              animation: "6s infinite ease-in-out yearanim3",
            })

            // gsap.set(dateElemSelector, {
            //   animation: "6s infinite ease-in-out float2",
            // })
            // gsap.set(logoSelector, {
            //   animation: "6s infinite ease-in-out float",
            // })

            // gsap.set(dateElemSelector, {
            //   animation: "6s infinite ease-in-out float2",
            // })
          }
        })

        gsap.set(date1Selector, {
          opacity: 1,
        })
        gsap.set(date2Selector, {
          opacity: 1,
        })
        gsap.set(date3Selector, {
          opacity: 1,
        })
        gsap.set(date4Selector, {
          opacity: 1,
        })
        gsap.set(date3CircleSelector, {
          opacity: 1,
        })
        gsap.set(labelSelector, {
          opacity: 1,
        })
        gsap.set(contentItemRightSelector, {
          opacity: 1,
        })
        gsap.set(contentItemleftSelector, {
          opacity: 1,
        }, "<")
        gsap.set(contentBottomSelector, {
          opacity: 1,
        });
        gsap.set(dateElem2Selector, {
          opacity: 1,
        });

        logoAnimation
          // .to(scrollSelector, {
          //   duration: .4,
          //   // delay: 50,
          //   opacity: 0,
          //   // transform: 'translateY(-50%)'
          // })
          .fromTo(logoSelector, {
            duration,
            // delay: 50,
            width: '100%',
          }, {
            duration,
            // delay: 50,
            width: '40%',
            top: 0,
            transform: "translateY(0)"
          })
          .from(date1Selector, {
            duration,
            // delay: 50,
            opacity: 0,
          })
          .from(date2Selector, {
            duration,
            // delay: 50,
            opacity: 0,
          })
          .from(date3Selector, {
            duration,
            // delay: 50,
            opacity: 0,
          })
          .from(date4Selector, {
            duration,
            // delay: 50,
            opacity: 0,
          })
          .from(date3CircleSelector, {
            duration,
            // delay: 50,
            opacity: 0,
          })
          .from(dateElem2Selector, {
            duration,
            // delay: 50,
            opacity: 0,
          }, "<")
          .from(labelSelector, {
            duration,
            // delay: 50,
            opacity: 0,
          })
          .from(contentItemRightSelector, {
            duration,
            delay: 50,
            x: '200%',
          })
          .from(contentItemleftSelector, {
            duration,
            delay: 50,
            x: '-200%',
          }, "<")
          .to(scrollSelector, {
            duration: .4,
            // delay: 50,
            opacity: 0,
            // transform: 'translateY(-50%)'
          })
          .from(contentBottomSelector, {
            duration,
            // delay: 50,
            opacity: 0,
          })
        // .set(logoSelector, {
        //   animation: "5s infinite linear float",
        // })
        // .set(dateElemSelector, {
        //   animation: "5s infinite linear float",
        // }, "<")
      }
    })

    gsap.set(date1Selector, {
      opacity: 0,
    })
    gsap.set(date2Selector, {
      opacity: 0,
    })
    gsap.set(date3Selector, {
      opacity: 0,
    })
    gsap.set(date4Selector, {
      opacity: 0,
    })
    gsap.set(date3CircleSelector, {
      opacity: 0,
    })
    gsap.set(labelSelector, {
      opacity: 0,
    })
    gsap.set(contentItemRightSelector, {
      opacity: 0,
    })
    gsap.set(contentItemleftSelector, {
      opacity: 0,
    }, "<")
    gsap.set(contentBottomSelector, {
      opacity: 0,
    });
    gsap.set(dateElem2Selector, {
      opacity: 0,
    });

    introAnimation
    
      .from(cubeBigSelector, {
        duration: mobileDuration,
        // delay: 50,
        scale: 0,
      })
      .from(cubeSmallSelector, {
        duration: .6,
        // delay: 50,
        scale: 0,
      })
      .from(label1Selector, {
        duration: .6,
        // delay: 50,
        // opacity: 0,
        xPercent: -200,
        y: 140,
      })
      .from(label1Selector, {
        duration: .6,
        delay: .2,
        opacity: 0,
        // xPercent: -200,
        // y: 140,
      }, "<")
      .from(underlinel1Selector, {
        duration: .6,
        // delay: 50,
        opacity: 0,
        xPercent: -200,
        y: 50,
      }, "<")
      .from(label2Selector, {
        duration: .6,
        // delay: 50,
        // opacity: 0,
        xPercent: -200,
        y: 90,
      })
      .from(label2Selector, {
        duration: .6,
        delay: .2,
        opacity: 0,
        // xPercent: -200,
        // y: 140,
      }, "<")
      .from(underlinel2Selector, {
        duration: .6,
        // delay: 50,
        opacity: 0,
        xPercent: -200,
        y: -50,
      }, "<")
      .from(label2ExlcSelector, {
        duration: .6,
        // delay: 50,
        opacity: 0,
        opacity: 0,
      }, "<")
      .from(label3Selector, {
        duration: .6,
        // delay: 50,
        // opacity: 0,
        xPercent: -200,
        y: -150,
      })
      .from(label3Selector, {
        duration: .6,
        delay: .2,
        opacity: 0,
        // xPercent: -200,
        // y: 140,
      }, "<")
      .from(underlinel3Selector, {
        duration: .6,
        // delay: 50,
        opacity: 0,
        xPercent: -200,
        y: -190,
      }, "<")
      .from(dateSelector, {
        duration: .6,
        // delay: 50,
        opacity: 0,
      })
      .from(scrollSelector, {
        duration: .6,
        // delay: 50,
        opacity: 0,
      })
  });

  mm.add("(max-width: 992px)", () => {
    introAnimation = gsap.timeline({

      onComplete: function () {

        logoAnimation = gsap.timeline({

          onComplete: function () {
            gsap.set(cubeBigSelector, {
              animation: "5s infinite ease-in-out cubeanim1",
            })
            gsap.set(cubeSmallSelector, {
              animation: "5s infinite ease-in-out cubeanim2",
            })

            gsap.set(label1Selector, {
              animation: "6s infinite ease-in-out labelanim1",
            })
            gsap.set(underlinel1Selector, {
              animation: "6s infinite ease-in-out lineanim1",
            })

            gsap.set(label2Selector, {
              animation: "6s infinite ease-in-out labelanim2",
            })
            gsap.set(underlinel2Selector, {
              animation: "6s infinite ease-in-out lineanim2",
            })

            gsap.set(label3Selector, {
              animation: "6s infinite ease-in-out labelanim3",
            })
            gsap.set(underlinel3Selector, {
              animation: "6s infinite ease-in-out lineanim3",
            })
            gsap.set(dateSelector, {
              animation: "6s infinite ease-in-out yearanim3",
            })
          }
        })

        gsap.set(date1Selector, {
          opacity: 1,
        })
        gsap.set(date2Selector, {
          opacity: 1,
        })
        gsap.set(date3Selector, {
          opacity: 1,
        })
        gsap.set(date4Selector, {
          opacity: 1,
        })
        gsap.set(date3CircleSelector, {
          opacity: 1,
        })
        gsap.set(labelSelector, {
          opacity: 1,
        })
        gsap.set(contentItemRightSelector, {
          opacity: 1,
        })
        gsap.set(contentItemleftSelector, {
          opacity: 1,
        }, "<")
        gsap.set(contentBottomSelector, {
          opacity: 1,
        });
        gsap.set(dateElem2Selector, {
          opacity: 1,
        });
      }
    })

    introAnimation
      .from(cubeBigSelector, {
        duration: mobileDuration,
        // delay: 50,
        scale: 0,
      })
      .from(cubeSmallSelector, {
        duration: mobileDuration,
        // delay: 50,
        scale: 0,
      })
      .from(label1Selector, {
        duration: mobileDuration,
        // delay: 50,
        // opacity: 0,
        xPercent: -200,
        y: 140,
      })
      .from(label1Selector, {
        duration: mobileDuration,
        delay: .2,
        opacity: 0,
        // xPercent: -200,
        // y: 140,
      }, "<")
      .from(underlinel1Selector, {
        duration: mobileDuration,
        // delay: 50,
        opacity: 0,
        xPercent: -200,
        y: 50,
      }, "<")
      .from(label2Selector, {
        duration: mobileDuration,
        // delay: 50,
        // opacity: 0,
        xPercent: -200,
        y: 90,
      })
      .from(label2Selector, {
        duration: mobileDuration,
        delay: .2,
        opacity: 0,
        // xPercent: -200,
        // y: 140,
      }, "<")
      .from(underlinel2Selector, {
        duration: mobileDuration,
        // delay: 50,
        opacity: 0,
        xPercent: -200,
        y: -50,
      }, "<")
      .from(label2ExlcSelector, {
        duration: mobileDuration,
        // delay: 50,
        opacity: 0,
        opacity: 0,
      }, "<")
      .from(label3Selector, {
        duration: mobileDuration,
        // delay: 50,
        // opacity: 0,
        xPercent: -200,
        y: -150,
      })
      .from(label3Selector, {
        duration: mobileDuration,
        delay: .2,
        opacity: 0,
        // xPercent: -200,
        // y: 140,
      }, "<")
      .from(underlinel3Selector, {
        duration: mobileDuration,
        // delay: 50,
        opacity: 0,
        xPercent: -200,
        y: -190,
      }, "<")
      .from(dateSelector, {
        duration: mobileDuration,
        // delay: 50,
        opacity: 0,
      })
      // .from(scrollSelector, {
      //   duration: mobileDuration,
      //   // delay: 50,
      //   opacity: 0,
      // })
      // .to(scrollSelector, {
      //   duration: mobileDuration,
      //   // delay: 50,
      //   opacity: 0,
      //   // transform: 'translateY(-50%)'
      // })
      .fromTo(logoSelector, {
        duration: mobileDuration,
        // delay: 50,
        width: '100%',
      }, {
        duration: mobileDuration,
        // delay: 50,
        width: '40%',
        top: 0,
        transform: "translateY(0)"
      })
      .from(date1Selector, {
        duration: mobileDuration,
        // delay: 50,
        opacity: 0,
      })
      .from(date2Selector, {
        duration: mobileDuration,
        // delay: 50,
        opacity: 0,
      })
      .from(date3Selector, {
        duration: mobileDuration,
        // delay: 50,
        opacity: 0,
      })
      .from(date4Selector, {
        duration: mobileDuration,
        // delay: 50,
        opacity: 0,
      })
      .from(date3CircleSelector, {
        duration: mobileDuration,
        // delay: 50,
        opacity: 0,
      })
      .from(dateElem2Selector, {
        duration: mobileDuration,
        // delay: 50,
        opacity: 0,
      }, "<")
      .from(labelSelector, {
        duration: mobileDuration,
        // delay: 50,
        opacity: 0,
      })
      .from(contentItemRightSelector, {
        duration: mobileDuration,
        // delay: 50,
        x: '200%',
      })
      .from(contentItemleftSelector, {
        duration: mobileDuration,
        // delay: 50,
        x: '-200%',
      }, "<")
      .from(contentBottomSelector, {
        duration: mobileDuration,
        // delay: 50,
        opacity: 0,
      })
  });

  return new Component({
    name: 'homeAnimations',
    requiredTargets: root,
    onCreate() { },
    onInit() { },
    onDestroy() { }
  })
}